/**
 * Odds comparison & strategy — `/betting-gaming/odds-comparison-strategy`
 */
import {
  ODDS_COMPARISON_STRATEGY_SLUG,
  oddsComparisonStrategyDefaultData,
} from "./oddsComparisonStrategyData";
import {
  OddsComparisonStrategyArticlesTab,
  OddsComparisonStrategyMediaTab,
  OddsComparisonStrategyOverviewTab,
} from "./OddsComparisonStrategyDesign";

export const oddsComparisonStrategyModule = {
  slug: ODDS_COMPARISON_STRATEGY_SLUG,
  getDefaultData: () => oddsComparisonStrategyDefaultData,
  Views: {
    overview: OddsComparisonStrategyOverviewTab,
    articles: OddsComparisonStrategyArticlesTab,
    media: OddsComparisonStrategyMediaTab,
  },
};
